import React, { PropsWithChildren, useContext, useMemo } from "react";
import { useRemotePromos } from "src/ssc-api/useRemotePromos";
import { byConfigurationCode } from "src/utils/promos";
import { DefaultNavBarQuery } from "types/graphql-types";

export type MenuPromosProviderContextValue =
  DefaultNavBarQuery["promos"]["nodes"];

const MenuPromosProviderContext =
  React.createContext<MenuPromosProviderContextValue>([]);

type Props = {
  content: DefaultNavBarQuery["promos"]["nodes"] | undefined;
};

export const MenuPromosProviderProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  content
}) => {
  const remoteOffers = useRemotePromos();

  const contextValue = useMemo(() => {
    return (
      content?.filter((p) => {
        if (p.hideInMainMenu) return false;

        const remote = remoteOffers.data?.find(
          byConfigurationCode(p.configuration?.code)
        );
        if (!remote) return false;

        return true;
      }) || []
    );
  }, [content, remoteOffers.data]);

  return (
    <MenuPromosProviderContext.Provider value={contextValue}>
      {children}
    </MenuPromosProviderContext.Provider>
  );
};

export const useMenuPromos = () => {
  return useContext(MenuPromosProviderContext);
};
